import { Page, Header, Content } from '@backstage/core-components';
import {
  HomePageToolkit,
  HomePageStarredEntities,
  HomePageRecentlyVisited,
  HomePageTopVisited,
  CustomHomepageGrid,
} from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import CategoryIcon from '@mui/icons-material/Category';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import ExtensionIcon from '@mui/icons-material/Extension';
import SearchIcon from '@mui/icons-material/Search';
import NotificationsIcon from '@mui/icons-material/Notifications';

const defaultConfig = [
  { component: 'HomePageSearchBar', x: 0, y: 0, width: 12, height: 2 },
  { component: 'HomePageToolkit', x: 0, y: 2, width: 6, height: 4 },
  { component: 'HomePageStarredEntities', x: 6, y: 2, width: 6, height: 4 },
  { component: 'HomePageRecentlyVisited', x: 0, y: 6, width: 6, height: 4 },
  { component: 'HomePageTopVisited', x: 6, y: 6, width: 6, height: 4 },
];

export const HomePage = () => {
  return (
    <Page themeId="home">
      <Header
        title="Welcome to CTM Backstage"
        subtitle="Your internal developer platform for building, managing, and discovering software across CTM."
      />
      <Content>
        <CustomHomepageGrid config={defaultConfig}>
          <HomePageSearchBar />
          <HomePageToolkit
            title="Quick Access"
            tools={[
              { url: '/catalog', label: 'Catalog', icon: <CategoryIcon /> },
              { url: '/create', label: 'Create', icon: <AddCircleOutlineIcon /> },
              { url: '/docs', label: 'Docs', icon: <LibraryBooksIcon /> },
              { url: '/api-docs', label: 'APIs', icon: <ExtensionIcon /> },
              { url: '/search', label: 'Search', icon: <SearchIcon /> },
              { url: '/notifications', label: 'Alerts', icon: <NotificationsIcon /> },
            ]}
          />
          <HomePageStarredEntities />
          <HomePageRecentlyVisited />
          <HomePageTopVisited />
        </CustomHomepageGrid>
      </Content>
    </Page>
  );
};
